import React from 'react'

const ErrorIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="425"
      height="407"
      viewBox="0 0 425 407"
    >
      <path
        fill="#4E4E4E"
        fillRule="evenodd"
        d="M173 0c139.176 0 252 112.824 252 252S312.176 504 173 504-79 391.176-79 252 33.824 0 173 0zm107.272 144.728c-10.972-10.97-28.76-10.97-39.73 0L173 212.27l-67.541-67.542-.332-.325c-10.995-10.645-28.537-10.536-39.399.325l-.325.332c-10.645 10.995-10.536 28.537.325 39.399L133.27 252l-67.542 67.541c-10.97 10.972-10.97 28.76 0 39.73 10.972 10.972 28.76 10.972 39.73 0L173 291.73l67.541 67.542.332.325c10.995 10.645 28.537 10.536 39.399-.325l.325-.332c10.645-10.995 10.536-28.537-.325-39.399L212.73 252l67.542-67.541c10.97-10.972 10.97-28.76 0-39.73z"
      />
    </svg>
  )
}

export default ErrorIcon
